export const WORKFLOW_QUERY = 'WORKFLOW';
export const WORKFLOW_API_URL = process.env.REACT_APP_API_SERVICE_URL;
